var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tip)?_c('div',{staticClass:"global-tip",class:_vm.tip.position || 'bottom-right'},[_c('div',{staticClass:"tip-content"},[_c('p',[_vm._v(_vm._s(_vm.tip.message))]),_c('button',{on:{"click":_vm.closeTip}},[_vm._v("×")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }